import { TeamId } from '../types';

export const teamQueryKeys = {
  base: () => ['teams'] as const,
  list: (params: unknown) => [...teamQueryKeys.base(), 'list', params] as const,
  item: (id: TeamId) => [...teamQueryKeys.base(), id] as const,
  memberships: (id?: TeamId) =>
    [...teamQueryKeys.base(), 'memberships', id] as const,
};
